import i18n from 'app-i18n';
import { DateTime } from 'luxon';

export const formatCreatedDate = (createdDate: string) =>
  !!createdDate
    ? DateTime.fromISO(createdDate).toLocaleString()
    : i18n.t('page.customers.overview.accountCreatedOnNA');
